import { Route, RouteComponentProps } from 'react-router-dom';
import { withSentryRouting } from '@sentry/react';
import { BlockComposer } from './compositions/Composer';
import { BlockListOverview } from './compositions/CompositionList';
import { SpeakManuscripts } from './utilities/speak-manuscripts/SpeakManuscripts';
import { BlockOverview } from './blocks/BlockOverview';
import BlockEditor from './blocks/BlockEditor';
import { BlockTagsOverview } from './blocks/BlockTagsOverview';

const SentryEnhancedRoute = withSentryRouting(Route);

type IProps = RouteComponentProps<void>;

export const BlockRoot = (props: IProps) => {
  const { match } = props;

  const renderBlockRoot = () => <h1>Block root</h1>;

  return (
    <>
      <SentryEnhancedRoute path={match.url} exact render={renderBlockRoot} />
      <SentryEnhancedRoute path="/block/composer" exact component={BlockListOverview} />
      <SentryEnhancedRoute path="/block/composer/:id" component={BlockComposer} />
      <SentryEnhancedRoute path="/block/composer/:id/:blockId" component={BlockComposer} />
      <SentryEnhancedRoute path="/block/overview/:id" component={BlockEditor} />
      <SentryEnhancedRoute path="/block/overview" component={BlockOverview} />
      <SentryEnhancedRoute path="/block/tags" exact component={BlockTagsOverview} />
      <SentryEnhancedRoute path="/block/speakManuscripts" exact component={SpeakManuscripts} />
    </>
  );
};
